/**
 * Class books on the client — the two things both shelves (the school console's
 * and the student's) need, defined once.
 */
import { apiGet } from '@/lib/api';

/** "4.2 MB", "820 KB". A book's size, for a person deciding whether to open it on data. */
export function formatBookSize(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

/**
 * Open a book in a new tab through a short-lived presigned link.
 *
 * The tab is opened FIRST, synchronously inside the click, and pointed at the
 * link once the API has issued it — a `window.open` after an await is a popup
 * the browser blocks. If the link cannot be issued, the blank tab is closed and
 * the error is the caller's to show. `opener` is cut so the PDF's origin gets
 * no handle back to this one.
 */
export async function openBook(urlEndpoint: string): Promise<void> {
  const tab = window.open('about:blank', '_blank');
  if (tab) tab.opener = null;
  try {
    const { url } = await apiGet<{ url: string; expiresInSeconds: number }>(urlEndpoint);
    if (tab) tab.location.href = url;
    else window.location.assign(url);
  } catch (err) {
    tab?.close();
    throw err;
  }
}
